import type { ReactElement } from "react";
import type { ProviderType } from "@/types";
import { getProviders } from "@/lib/provider/meta";

type IconProps = { className?: string };

export const PROVIDER_ICON: Partial<Record<ProviderType, (props: IconProps) => ReactElement>> =
  getProviders().reduce(
    (acc, p) => {
      acc[p.id] = (props: IconProps) => <img src={p.logoUrl} alt={p.name} {...props} />;
      return acc;
    },
    {} as Partial<Record<ProviderType, (props: IconProps) => ReactElement>>
  );
